import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Prevent body scroll when sidebar is open
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    // Scroll to top on navigation - Layout component'i de bunu yapacak ama burada da ekliyoruz hızlı olması için
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <>
      {/* Overlay for mobile sidebar */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-sidebar-overlay" 
          onClick={toggleMobileMenu}
        ></div>
      )}
      
      {/* Mobile Sidebar - Header dışında */}
      <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
        <button className="sidebar-close-btn" onClick={toggleMobileMenu}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        
        <Link 
          to="/" 
          onClick={handleNavClick}
          className={location.pathname === '/' ? 'active' : ''}
        >
          Ana Sayfa
        </Link>
        <Link 
          to="/services" 
          onClick={handleNavClick}
          className={location.pathname === '/services' ? 'active' : ''}
        >
          Hizmetler
        </Link>
        <Link 
          to="/projects" 
          onClick={handleNavClick}
          className={location.pathname === '/projects' ? 'active' : ''}
        >
          Projelerimiz
        </Link>
        <Link 
          to="/contact" 
          onClick={handleNavClick}
          className={location.pathname === '/contact' ? 'active' : ''}
        >
          İletişim
        </Link>
        <button className="theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}>
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
      </nav>
      
      <header className={`header ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'sidebar-open' : ''}`}>
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo" onClick={handleNavClick}>
              <img src="/lysep_logo.svg" alt="LYSEP CORPORATION Logo" className="logo-image" />
              <div className="logo-text">
                <h2 className="logo-short"><span className="lysep-text">LYSEP</span></h2>
                <h2 className="logo-full"><span className="lysep-text">LYSEP</span>
                <span className="corp-text">CORP</span>
                </h2>
              </div>
            </Link>
            
            {/* Desktop Navigation */}
            <nav className="nav desktop-nav">
              <Link 
                to="/" 
                onClick={handleNavClick}
                className={location.pathname === '/' ? 'active' : ''}
              >
                Ana Sayfa
              </Link>
              <Link 
                to="/services" 
                onClick={handleNavClick}
                className={location.pathname === '/services' ? 'active' : ''}
              >
                Hizmetler
              </Link>
              <Link 
                to="/projects" 
                onClick={handleNavClick}
                className={location.pathname === '/projects' ? 'active' : ''}
              >
                Projelerimiz
              </Link>
              <Link 
                to="/contact" 
                onClick={handleNavClick}
                className={location.pathname === '/contact' ? 'active' : ''}
              >
                İletişim
              </Link>
              <button className="theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}>
                {theme === 'dark' ? '☀️' : '🌙'}
              </button>
            </nav>

            <button className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
